module.exports = __webpack_public_path__ + "img/compliance.3b4d0c07.png";